module.exports = __webpack_public_path__ + "static/harry-potter-and-the-goblet-of-fire-9fbb6ed6c96363a57e488d22d17c2cbb.jpg";